import { compose, head, split } from 'ramda'
import queryString from 'query-string'

export const useLocation = () => {
  return window.location
}

// TODO: Depracated - use getQueryParams from utils/helpers/url
export const useQueryParams = () => {
  const loc = useLocation()
  return queryString.parse(loc.search) || {}
}

// TODO: Depracated - use getSubdomain from utils/helpers/url
export const useSubdomain = () => {
  const loc = useLocation()
  return compose(head, split('.'))(loc.hostname)
}
